export default __webpack_public_path__ + "static/media/36I-102612_-17021_0.8fd97a31.jpg";